import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_JOB_PACK = restRequest("VRCORE.JOB_PACK_V3.GET_JOB_PACK");
export const GET_NEW_JOB_PACK_UID = restRequest(
    "VRCORE.JOB_PACK_V3.GET_NEW_JOB_PACK_UID"
);
export const SET_JOB_PACK = restRequest("VRCORE.JOB_PACK_V2.SET_JOB_PACK");
export const SUBMIT_JOB_TYPE = restRequest(
    "VRCORE.JOB_PACK_V3.SUBMIT_JOB_TYPE"
);
export const GET_JOB_TYPES = restRequest("VRCORE.JOB_PACK_V3.GET_JOB_TYPES");
export const SET_JOB_TYPE = "VRCORE.JOB_PACK_V3.SET_JOB_TYPE";
export const GET_JOB_PACK_All_IDS = restRequest(
    "VRCORE.JOB_PACK_V3.GET_JOB_PACK_All_IDS"
);
export const GET_JOB_PENDING_All_IDS = restRequest(
    "VRCORE.JOB_PACK_V3.GET_JOB_PENDING_All_IDS"
);

export const GET_JOB_ARCHIVED_All_IDS = restRequest(
    "VRCORE.JOB_PACK_V3.GET_JOB_ARCHIVED_All_IDS"
);
export const GET_ALL_USERS = restRequest("VRCORE.JOB_PACK_V3.GET_ALL_USERS");

export const GET_ALL_TOOLBOXES = restRequest(
    "VRCORE.JOB_PACK_V3.GET_ALL_TOOLBOXES"
);
export const GET_ALL_QUALIFICATIONS = restRequest(
    "VRCORE.JOB_PACK_V3.GET_ALL_QUALIFICATIONS"
);

export const GET_TOTAL = restRequest("VRCORE.JOB_PACK_V3.GET_TOTAL");
export const SET_JOB_PACK_COUNT = restRequest(
    "VRCORE.JOB_PACK_V3.SET_JOB_PACK_COUNT"
);
